export const PlecaMorada = ()=>{
    return (
    <div className="container-fluid mt-3">
        <div className="row">
            <div className="col-12 divider_purple"></div>
        </div>
    </div>
    )
}